import { ButtonSizeOptions, InputText } from "@loanbossinc/component-library";
import { Checkbox } from "@material-ui/core";
import { withFormik } from "formik";
import React, { useCallback, useEffect } from "react";

import {
  BackButton,
  CheckboxContainer,
  CheckboxGroup,
  DealName,
  InputName,
  InputWrapper,
  StyledPrimaryButton,
  Title,
  StyledDeleteButton,
  BackDeleteWrapper
} from "./styles";

const Step1 = props => {
  const {
    deal,
    handleSubmit,
    history,
    location,
    match: {
      params: { dealId, reportId }
    },
    wizardStepDecrement,
    isSubmitting,
    setFieldValue,
    values,
    isEditing,
    setSelections,
    reportSelections
  } = props;
  const { reportName, shouldCalculateDebtYield, shouldCalculateDscr } = values;

  const isCalculationTypeSelected = Boolean(reportName) || Boolean(reportSelections.reportName);

  useEffect(() => {
    if (Boolean(reportSelections.reportName) && !reportName) {
      setFieldValue("reportName", reportSelections.reportName);
    }
    const urlDealId = dealId ? dealId : reportSelections.selectedDealId ? reportSelections.selectedDealId : "notSelected";
    const urlReportId = reportId ? reportId : "new";
    history.replace(`/deal/${urlDealId}/lender-reports-setup/${urlReportId}`, { from: "undefined-6" });

    if (urlDealId !== "notSelected") {
      setFieldValue("dealId", Number(urlDealId));
    }
  }, [reportSelections]);

  const onTextChange = event => {
    const {
      target: { value }
    } = event;

    setFieldValue("reportName", value);
  };

  const onCheckboxChange = event => {
    const {
      target: { id }
    } = event;

    switch (id) {
      case "dscr":
        setFieldValue("shouldCalculateDscr", !shouldCalculateDscr);
        break;
      case "debt-yield":
        setFieldValue("shouldCalculateDebtYield", !shouldCalculateDebtYield);
        break;
      default:
        break;
    }
  };
  const handleGoBack = () => {
    console.log("handleGoBack", location.state?.from);

    if (location.state?.from === "edit-report-hero-card") {
      history.push(`/deal/${dealId}/lender-reports/${reportId}`);
    } else {
      wizardStepDecrement();
    }
  };
  const handleDelete = () => {
    setSelections({ isDeleteDialogOpen: true, wizardStep: 0 });
  };

  return (
    <>
      <Title>Customize report content</Title>
      <DealName>{deal && deal.name}</DealName>
      <InputWrapper>
        <InputText value={reportName} onChange={onTextChange} variant="filled" id="report-name" name="report-name" label="Report Name" fullWidth />
      </InputWrapper>
      <InputWrapper>
        <InputName value="Select calculations (Optional)" />
        <CheckboxGroup>
          <CheckboxContainer>
            <Checkbox id="dscr" checked={shouldCalculateDscr} onChange={onCheckboxChange} />
            DSCR
          </CheckboxContainer>
          <CheckboxContainer>
            <Checkbox id="debt-yield" checked={shouldCalculateDebtYield} onChange={onCheckboxChange} />
            Debt Yield
          </CheckboxContainer>
        </CheckboxGroup>
      </InputWrapper>
      <StyledPrimaryButton
        disabled={isSubmitting || !isCalculationTypeSelected}
        size={ButtonSizeOptions.lg}
        label="Setup Reporting Periods"
        style={{ width: "100%" }}
        onClick={handleSubmit}
      />
      <BackDeleteWrapper>
        <BackButton onClick={handleGoBack} id="back-button" label={location.state?.from === "edit-report-hero-card" ? "Report summary" : "Create a new lender report"} iconName="arrow_forward" reverse alignRight={false} key={1} />
        {isEditing && <StyledDeleteButton label="Discard report" onClick={handleDelete} />}
      </BackDeleteWrapper>
    </>
  );
};

export default withFormik({
  mapPropsToValues: ({ reportConfig }) => ({ ...reportConfig }),
  handleSubmit(values, { props, setSubmitting }) {
    const { wizardStepIncrement, postReportConfig } = props;
    postReportConfig({ data: { ...values } });
    setSubmitting(false);
    wizardStepIncrement();
  }
})(Step1);
